module.exports = __webpack_public_path__ + "static/how-it-works-3-231bdf422935f70351cfba4af9137512.png";